import { createSlice } from "@reduxjs/toolkit";
import CustomAxios from "../utilities/service/api.service";
import CheckAuthorization from "../utilities/auth/checkAuthorization";
import { API } from "../utilities/constants";
import { showErrorMessage } from "../utilities/helperFns";

const initialState = {
  loading: 0,
  datasetData: [],
};

const datasetsSlicer = createSlice({
  name: "datasets",
  initialState,
  reducers: {
    setLoading: (state, action) => ({
      ...state,
      loading: state.loading + (action.payload ? 1 : -1),
    }),
    setDatasetData: (state, action) => ({
      ...state,
      datasetData: action.payload,
    }),
  },
});

export const { setLoading, setDatasetData } = datasetsSlicer.actions;
//function to obtain the information related to datasets in home page (Data Cards)
export const getDatasetsRefresh = () => async (dispatch, getState) => {
  dispatch(setLoading(true));
  CustomAxios(API.datasetslist, "GET")
    .then((response) => {
      const data = response.data;
      dispatch(setDatasetData(data));
      dispatch(setLoading(false));
    })
    .catch((err) => {
      if (err.status === 403) {
        CheckAuthorization();
      }
      showErrorMessage();
      dispatch(setLoading(false));
    });
};

export default datasetsSlicer.reducer;
